export default {
  'brand.name': 'USFans Spreadsheet',
  'nav.home': 'Home',
  'nav.guides': 'Guides',
  'nav.buyingGuide': 'Buying Guide',
  'nav.review': 'Review',
  'nav.shipping': 'Shipping',
  'nav.safety': 'Safety',
  'nav.faq': 'FAQ',
  'nav.buyNow': 'Buy It Now',
  'lang.label': 'Language',
  'lang.en': 'English',
  'lang.pl': 'Polski',
  'lang.es': 'Español',
  'lang.fr': 'Français',

  'footer.tagline': 'An independent informational resource for USFans Spreadsheet research.',
  'footer.disclaimer': 'This website is an independent informational resource. It is not officially affiliated with or endorsed by USFans unless explicitly stated.',
  'footer.col.explore': 'Explore',
  'footer.col.guides': 'Guides',
  'footer.col.legal': 'Legal',
  'footer.about': 'About',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.disclaimerLink': 'Disclaimer',
  'footer.copyright': '© 2026 USFans Spreadsheet. All rights reserved.',

  'common.readMore': 'Read more',
  'common.backHome': 'Back to homepage',
  'common.explore': 'Explore USFans Spreadsheet',
};